import {
  FluidComponentDefinition,
  FluidRowData,
  FluidTableHeader,
} from '@lmig/fluid-core';
import { h } from '@stencil/core';

import { FluidComponentFromDefinition } from '../../../common/fluid-component-rendering.components';
import { Utils } from '../../../utils/utils';

export type AdditionalHeaderRowProps = {
  headers: FluidTableHeader[];
  dataItems: FluidRowData[];
  selectable: boolean;
  allowTabIndexRows: boolean;
  allowTabIndexCells: boolean;
};

export const AdditionalHeaderRow = (props: AdditionalHeaderRowProps) => {
  const {
    headers,
    dataItems,
    selectable,
    allowTabIndexRows,
    allowTabIndexCells,
  } = props;
  const shouldRender = headers.some(
    (h) => h.grouping?.headerValue && h.grouping?.additionalHeaderRow
  );

  return shouldRender ? (
    <tr
      class={'fluid-table-additional-header-row'}
      tabIndex={Utils.setTabIndex(allowTabIndexRows)}>
      {selectable ? <td /> : null}
      {headers
        .slice(0)
        .reverse()
        .map((header) => {
          const headerValue = header.grouping?.headerValue;
          return (
            header.visible && (
              <td tabIndex={Utils.setTabIndex(allowTabIndexCells)}>
                {headerValue && (
                  <RenderValue
                    value={headerValue(dataItems)}
                    renderComponent={header.grouping?.headerRenderComponent}
                  />
                )}
              </td>
            )
          );
        })}
      <td class='table-data-cell action-cell' />
    </tr>
  ) : null;
};

const RenderValue = (props: {
  value: any;
  renderComponent?: (value) => FluidComponentDefinition;
}) => {
  return props.renderComponent
    ? [
        <FluidComponentFromDefinition
          definition={props.renderComponent(props.value)}
        />,
      ]
    : [props.value];
};
